import axios from 'axios';
import {
    getToken,
} from '../helpers/handleToken';
import refreshTokenManager from './RefreshTokenManager';

class BaseService {
    constructor(baseUrl = process.env.REACT_APP_API_URL) {
        this.api = axios.create({
            baseURL: baseUrl,
            headers: { 'Content-Type': 'application/json' },
        });

        this.api.interceptors.request.use((config) => {
            const token = getToken();
            if (token) {
                config.headers.Authorization = `Bearer ${token}`;
            }
            return config;
        });

        this.api.interceptors.response.use(
            (response) => response.data,
            async (error) => {
                const originalRequest = error.config;

                if (error.response && error.response.status === 401 && !originalRequest._retry) {
                    originalRequest._retry = true;

                    return new Promise((resolve, reject) => {
                        refreshTokenManager.addRequest(async (newToken) => {
                            try {
                                originalRequest.headers.Authorization = `Bearer ${newToken}`;
                                const response = await this.api(originalRequest);
                                resolve(response);
                            } catch (err) {
                                reject(err);
                            }
                        });

                        refreshTokenManager.refreshAccessToken(this.api).catch(reject);
                    });
                }

                if (error.response && error.response.status === 403) {
                    localStorage.removeItem('accessToken');
                    localStorage.removeItem('refreshToken');
                    localStorage.removeItem('uniqueUserStr');
                    window.location.reload();
                }

                return Promise.reject(error);
            },
        );
    }

    get = (url, options) => this.api.get(url, options);

    post = (url, data, options) => this.api.post(url, data, options);

    put = (url, data, options) => this.api.put(url, data, options);

    patch = (url, data, options) => this.api.patch(url, data, options);

    delete = (url, options) => this.api.delete(url, options);
}

export default BaseService;
